import utility from "src/utils/utility"
import { PageWrapper, PageTitle, CustomContainer } from "src/style"

const Products: React.FC = () => {

    return (
        <>
            <PageWrapper>
                <PageTitle 
                    color='#101828' textSize='3' fontWeight="500"
                >
                    Products
                </PageTitle>
                <CustomContainer topMargin='2'>

                </CustomContainer>
            </PageWrapper>
        </>
    )
}

export default utility.routeData('products', 'Products', <Products/>)